import client from './apollo-client'

export default client
